import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import BigModuleHead from '@src/pc/index/components/BigModuleHead';
import Chip from 'Chip';

const Thanks = ({ thanksHead, thanksAd }) => {
    return (
        <div className={styles.thanks}>
            <Chip id="260484" type="struct" title="鸣谢专区头" content={thanksHead}>
                <BigModuleHead />
            </Chip>
            <Chip id="260491" type="struct" title="鸣谢专区广告图片列表" content={thanksHead}>
                <div className={styles.thanksBox}>
                    {thanksAd?.thankList?.map((item, index) => {
                        return (
                            <a href={item.url} key={index} target="_blank">
                                <img className={styles.thanksPic} src={item.imageUrl} />
                            </a>
                        );
                    })}
                </div>
            </Chip>
        </div>
    );
};

Thanks.propTypes = {
    thanksHead: PropTypes.object,
    thanksAd: PropTypes.object,
};

export default errorBoundary(Thanks);
